import { BusStop } from "../busStop";

export const getBusStopLabel = (busStop: BusStop): string => {
  return busStop.address;
};

export const getBusStopName = (busStop: BusStop): string => {
  return busStop.name;
};
